<template>
  <div>
    <hr-dialog width="80%" :visible.sync="visible" :title="title" :handleClose="handleClose">
    <template slot="title" v-if="form.executeStatus+''&&operatorModel!='update'">
     
       <el-tag :type="form.executeStatus=='0'?'success':'danger'">{{executeStatusLable(form.executeStatus)}}</el-tag>
    </template>
      <template slot="body">
        <div>
          <el-form :model="form" ref="formRef" :rules='formRules' label-width="120px" id='lhr'>
            <el-row :gutter="24">
              <el-col :span="24">
                <div>
                  <span>立项信息</span>
                  <el-divider></el-divider>
                </div>
              </el-col>
              <el-col :span="8">
                <el-form-item label="医院名称" prop="projectId">
                  <el-select
                    v-model="form.projectId"
                    style="width:100%"
                    placeholder="请选择 医院名称"
                    :disabled="operatorModel=='view'||operatorModel=='update'"
                    @change="projectIdChange"
                  >
                    <el-option
                      v-for="item in projectList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目编号" prop="code">
                  <el-input
                    clearable
                    v-model="form.code"
                    :disabled="operatorModel=='view'"
                    placeholder="请输入 项目编号"
                    maxlength="30"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="项目名称" prop="name">
                  <el-input
                    clearable
                    v-model="form.name"
                    :disabled="operatorModel=='view'"
                    placeholder="请输入 项目名称"
                    maxlength="30"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目年度" prop="annual">
                  <el-date-picker 
                  clearable
                    v-model="form.annual" 
                    type="year"
                    :disabled="operatorModel=='view'"
                    value-format="yyyy"
                   placeholder="请选择 项目年度">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目节点" prop="progressStage">
                  <el-select
                  clearable
                    v-model="form.progressStage"
                    :disabled="operatorModel=='view'"
                    style="width:100%"
                    placeholder="请选择 项目节点"
                    
                  >
                    <el-option
                      v-for="item in progressStageList"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="String(item.dictKey)"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目负责人" prop="chargeUserId">
                   <choice-people :limit="1" :disabled="operatorModel=='view'" :allUserList='realInspectManList' :remainUserListInside.sync="realInspectManList" :projectId="form.projectId"  message="请选择 负责人"  ></choice-people>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="立项方式" prop="startupWay">
                  <el-select clearable v-model="form.startupWay" :disabled="operatorModel=='view'" style="width:100%" placeholder="立项方式">
                    <el-option
                    
                      v-for="item in startupWayList"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="String(item.dictKey)"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="立项日期" prop="startupDate">
                  <el-date-picker popper-class='ooop' v-model="form.startupDate"
                  clearable
                  :disabled="operatorModel=='view'" 
                    value-format="yyyy-MM-dd HH:mm:ss"
                   type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="预算金额（万）" prop="budgetAmount">
                  <moneyInput
                    v-model="form.budgetAmount"
                    :disabled="operatorModel=='view'"
                    placeholder="请输入 预算金额"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>

              <!-- 招议标信息 -->
              <el-col :span="24">
                <div>
                  <span>招议标信息</span>
                  <el-divider></el-divider>
                </div>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.bidFileUploadDate,form.engineeringPlan.bidFileUploadDate]' label="招标文件上传" prop="bidFileUploadDate	">
                  <el-date-picker
                    v-isRed='[form.bidFileUploadDate,form.engineeringPlan.bidFileUploadDate]'
                    clearable
                    v-model="form.bidFileUploadDate"
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.bidFileUploadDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.bidFileUploadDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.bidApproveFinishDate,form.engineeringPlan.bidApproveFinishDate]' label="招标审批完成" prop="bidApproveFinishDate">
                  <el-date-picker
                  v-isRed='[form.bidApproveFinishDate,form.engineeringPlan.bidApproveFinishDate]'
                  clearable
                    v-model="form.bidApproveFinishDate"
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.bidApproveFinishDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.bidApproveFinishDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.bidOpenDate,form.engineeringPlan.bidOpenDate]'  label="开标/议标日期"  prop="bidOpenDate">
                  <el-date-picker clearable v-isRed='[form.bidOpenDate,form.engineeringPlan.bidOpenDate]' :disabled="operatorModel=='view'" v-model="form.bidOpenDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.bidOpenDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.bidOpenDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.businessNegotiationDate,form.engineeringPlan.businessNegotiationDate]' label="商务谈判日期" prop="businessNegotiationDate">
                  <el-date-picker
                    v-model="form.businessNegotiationDate"
                    v-isRed='[form.businessNegotiationDate,form.engineeringPlan.businessNegotiationDate]'
                    clearable
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.businessNegotiationDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.businessNegotiationDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item  v-isRedLable='[form.bidWinningNoticeDate,form.engineeringPlan.bidWinningNoticeDate]' label="中标通知日期" prop="bidWinningNoticeDate">
                  <el-date-picker
                  clearable
                    v-model="form.bidWinningNoticeDate"
                    v-isRed='[form.bidWinningNoticeDate,form.engineeringPlan.bidWinningNoticeDate]'
                    :disabled="operatorModel=='view'"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.bidWinningNoticeDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.bidWinningNoticeDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item  label="中标单位" prop="partnerId">
                  <el-select
                    v-model="form.partnerId"
                    style="width:100%"
                    placeholder="请选择 中标单位"
                    :disabled="operatorModel=='view'"
                    @change="partnerIdChange"
                    clearable
                  >
                    <el-option
                      v-for="item in supplierList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 合同信息 -->
              <el-col :span="24">
                <div>
                  <span>合同信息</span>
                  <el-divider></el-divider>
                </div>
              </el-col>
              <el-col :span="8">
                <el-form-item  v-isRedLable='[form.contractCountersignDate,form.engineeringPlan.contractCountersignDate]' label="合同会签日期" prop="contractCountersignDate">
                  <el-date-picker clearable v-isRed='[form.contractCountersignDate,form.engineeringPlan.contractCountersignDate]' value-format="yyyy-MM-dd HH:mm:ss" :disabled="operatorModel=='view'" v-model="form.contractCountersignDate" type="date" placeholder="选择日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.contractCountersignDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.contractCountersignDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
                
              </el-col>
              <el-col :span="8">
                <el-form-item label="合同金额（万）" prop="contractAmount">
                  <moneyInput
                    v-model="form.contractAmount"
                    :disabled="operatorModel=='view'"
                    placeholder="请输入 合同金额"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.contractSignDate,form.engineeringPlan.contractSignDate]' label="合同签订日期" prop="contractSignDate">
                  <el-date-picker clearable v-isRed='[form.contractSignDate,form.engineeringPlan.contractSignDate]' :disabled="operatorModel=='view'" v-model="form.contractSignDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择 合同签订日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.contractSignDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.contractSignDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="合同工期（天）" prop="contractLimitDay">
                    <el-input  clearable :disabled="operatorModel=='view'"  maxlength="4"  @keyup.native="prevent($event)" v-model="form.contractLimitDay" style="width: 100%"  @input="contractLimitDayInput"></el-input>
                  
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="施工方联系人" prop="workChargeName">
                  <el-input
                    clearable
                    v-model="form.workChargeName"
                    :disabled="operatorModel=='view'"
                    placeholder="请输入 施工方联系人"
                    maxlength="30"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="施工方电话" prop="workChargeTel">
                  <el-input
                    clearable
                    v-model="form.workChargeTel"
                    :disabled="operatorModel=='view'"
                    placeholder="请输入 施工方电话"
                    maxlength="30"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 施工结算信息 -->
              <el-col :span="24">
                <div>
                  <span>施工结算信息</span>
                  <el-divider></el-divider>
                </div>
              </el-col>

              <el-col :span="8">
                <el-form-item v-isRedLable='[form.workStartDate,form.engineeringPlan.workStartDate]' label="开工日期" prop="workStartDate">
                  <el-date-picker clearable v-isRed='[form.workStartDate,form.engineeringPlan.workStartDate]' :disabled="operatorModel=='view'" v-model="form.workStartDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.workStartDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.workStartDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.workFinishDate,form.engineeringPlan.workFinishDate]' label="竣工日期" prop="workFinishDate">
                  <el-date-picker clearable v-isRed='[form.workFinishDate,form.engineeringPlan.workFinishDate]' :disabled="operatorModel=='view'" v-model="form.workFinishDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.workFinishDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.workFinishDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.settlementDataSubmitDate,form.engineeringPlan.settlementDataSubmitDate]' label="结算资料送审" prop="settlementDataSubmitDate">
                  <el-date-picker clearable v-isRed='[form.settlementDataSubmitDate,form.engineeringPlan.settlementDataSubmitDate]' :disabled="operatorModel=='view'" v-model="form.settlementDataSubmitDate"  value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.settlementDataSubmitDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.settlementDataSubmitDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.auditReportDate,form.engineeringPlan.auditReportDate]' label="审计报告" prop="auditReportDate">
                  <el-date-picker clearable v-isRed='[form.auditReportDate,form.engineeringPlan.auditReportDate]' :disabled="operatorModel=='view'" v-model="form.auditReportDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.auditReportDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.auditReportDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="审定金额（万）" prop="auditAmount">
                  <moneyInput
                  :disabled="operatorModel=='view'"
                    v-model="form.auditAmount"
                    placeholder="请输入 预算金额"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="预付款（万）" prop="prepayAmount">
                  <moneyInput
                  :disabled="operatorModel=='view'"
                    v-model="form.prepayAmount"
                    placeholder="请输入 预付款"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="进度款（万）" prop="progressAmount">
                  <moneyInput
                  :disabled="operatorModel=='view'"
                    v-model="form.progressAmount"
                    placeholder="请输入 进度款"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="质保金额（万）" prop="qualityGuaranteeAmount">
                  <moneyInput
                  :disabled="operatorModel=='view'"
                    v-model="form.qualityGuaranteeAmount"
                    placeholder="请输入 质保金额"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-isRedLable='[form.qualityGuaranteePayDate,form.engineeringPlan.qualityGuaranteePayDate]' label="质保金支付" prop="qualityGuaranteePayDate">
                  <el-date-picker clearable v-isRed='[form.qualityGuaranteePayDate,form.engineeringPlan.qualityGuaranteePayDate]'  :disabled="operatorModel=='view'" v-model="form.qualityGuaranteePayDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                  </el-date-picker>
                  <span class="tipDate" v-if="form.engineeringPlan.qualityGuaranteePayDate&&operatorModel=='view'">计划日期:{{dayjs(form.engineeringPlan.qualityGuaranteePayDate).format('YYYY-MM-DD')}}</span>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="备注" prop="remark">
                  <el-input
                  clearable
                    type="textarea"
                    :disabled="operatorModel=='view'"
                    :rows="4"
                    style="width: 100%"
                    placeholder="请输入内容"
                    v-model="form.remark"
                    show-word-limit
                    maxlength="300"
                  >
                  </el-input>
                </el-form-item>
              </el-col>

              
              <el-col :span="24">
                <el-form-item label="项目档案" prop="fileAttach">
                  <VUpload :disabled="operatorModel=='view'" :fileList="form.fileAttach" :max="10 * 1024 * 1024" :limit="15">
                  
                  </VUpload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
      <template slot="footer" v-if="operatorModel!='view'">
        <div style="float:right;margin-right:24px;">
                            <el-button type="primary" icon='el-icon-circle-check' size="small" @click="submit" style="margin-right: 20px"  >{{operatorModel == 'add' ?'保存':'修改'}}</el-button>
                            <el-button icon="el-icon-circle-close" size="small" @click="cancle">取消</el-button>
        </div>
      </template>
    </hr-dialog>
    <el-dialog
      title="设备设施信息数据导入"
      append-to-body
      :visible.sync="showUploadDialog"
      :close-on-click-modal="false"
      width="555px"
      accept="vnd.ms-excel"
    >
      <avue-form v-if="showUploadDialog" :option="excelOption" ref="excelform" v-model="upload" :upload-after="uploadAfter"
                 :before-upload="beforeUpload">

        <template slot-scope="scope" slot="downloadAction">
            模板下载:
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            v-if="permission.device_add"
            @click="exportDeviceDemoExcel"
          >下载模板
          </el-button>
            <!-- <el-button @click="tip">自定义按钮</el-button> -->
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import moneyInput from '@/components/money-input/index2.vue';
import VUpload from '@/views/components/v-upload';
import { getDictionary } from '@/api/common';
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary'; //项目字典
import {
  add,
  getsupplierList,
  getDetail,
  getList,
  remove,
  update,
  getChargeMan,
} from '@/api/v4ward/engineering/engineering';
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import dayjs from 'dayjs';
let MODEL = ''
export default {
  components: {
    moneyInput,
    VUpload,
    choicePeople
  },
  props: {
    form: {
      default: () => {
        return {};
      },
      type: Object,
    },
    rowData:{//列表的数据

    },
    visible: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
    operatorModel: {
      default: 'add',
      type: String,
    },
   
  },
  data() {
    return {
      realInspectManList:[],
      projectList: [],
      progressStageList: [],
      startupWayList: [],
      supplierList:[],
      formRules: {
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        code: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        annual: [{ required: true, message: '请选择项目年度', trigger: 'blur' }],
        progressStage:[{ required: true, message: '请选择项目节点', trigger: 'change' }],
        chargeUserId:[{ required: true, message: '请选择负责人', trigger: 'change' }],
        startupWay	:[{ required: true, message: '请选择立项方式', trigger: 'change' }],
        startupDate :[{ required: true, message: '请选择项目年度', trigger: 'blur' }],
        budgetAmount:[{ required: true, message: '请输入预算金额', trigger: 'blur' }]
      },
    };
  },
 watch:{
    realInspectManList: {
      handler() {
         console.log(this.realInspectManList[0])
        if(this.realInspectManList.length>0){
          console.log(this.realInspectManList[0])
          this.$set(this.form,"chargeUserId",this.realInspectManList[0].id)
           this.form.chargeUserName = (this.realInspectManList[0].realName).replace(/\([0-9]*\)(?!.*\1)/g, ``);//删除手机号
          console.log( this.form.chargeUserId)
        }
          
      },
      immediate: true,
      deep: true,
    },
 },
  created() {
    MODEL = this.operatorModel
    console.log("新增form",this.form)
    this.initDic(this.form.projectId)
    this.initData();
    if(this.form.chargeUserId){
      this.realInspectManList.push({
         id: this.form.chargeUserId,
          realNameAndPhone: this.form.chargeUserName,
          realName: this.form.chargeUserName,
    })
    }
    
    
  },
  directives: {
    isRed: {
      // 指令的定义
      bind:  (el, binding, vnode) =>{
        let date1 =binding.value[0]? new Date(binding.value[0]) :new Date()
        date1 = dayjs(date1).format(
          'YYYY-MM-DD 00:00:00'
        );
        date1= new Date(date1)
      
        let date2 = new Date(binding.value[1]) 
      
           
         
         if(date1>date2&&MODEL=='view'){
             let dom = el.querySelector('input')
            dom.classList.add("lhrred" )
         }
        
        
      }
    },
    isRedLable: {
      // 指令的定义
      bind:  (el, binding, vnode) =>{
        let date1 =binding.value[0]? new Date(binding.value[0]) :new Date()
        let date2 = new Date(binding.value[1]) 
       date1 = dayjs(date1).format(
          'YYYY-MM-DD 00:00:00'
        );
        date1= new Date(date1)
           
         console.log("label",el)
         if(date1>date2&&MODEL=='view'){
             let dom = el.querySelector('label')
            dom.classList.add("lhrred" )
         }
        
        
      }
    }
  },
  mounted(){
    this.overDateTransformRed()
  },
  methods: {
    partnerIdChange(val){
      let partnerName = ''
      this.supplierList.forEach((item,index)=>{
        if(val ==item.id){
          partnerName = item.name
        }
      })
      this.form.partnerName = partnerName
    },
    cancle(){
       this.visible = false 
          this.$emit("update:visible",this.visible)
    },
    overDateTransformRed(){
     setTimeout(() => {
        console.log('red',this.$refs.formRef)
     }, 0);
    },
    executeStatusLable(value){
      
      if(value ==1){
        return "延期"
      }else{
        return "正常"
      }
      
    },
    prevent(e){
    var keynum = window.event ? e.keyCode : e.which;   //获取键盘码
        if (keynum ==189|| keynum==190||keynum == 109 ||keynum == 110 ) {
            
            e.target.value = ''
        }
    },
    contractLimitDayInput(){
      this.form.contractLimitDay = String(this.form.contractLimitDay).replace(/^(0+)|[^\d]+/g, '');
    },
    projectIdChange(){
      this.initDic(this.form.projectId)
      this.tool.clearObject(this.form,'projectId')
      this.realInspectManList=[]
    },
    initDic(id) {
      this.getStartupWayList(id);
      this.getProgressStageList(id);
      this.getsupplierList(id)
    },
    getStartupWayList(projectId) {
      //立项方式
      getProjectDict({
        code: 'engineering_startup_way',
        projectId: projectId,
      }).then((res) => {
        this.startupWayList = res.data;
      });
    },
    //工程项目节点
    getProgressStageList(projectId) {
      getProjectDict({
        code: 'engineering_progress_stage',
        projectId: projectId,
      }).then((res) => {
        this.progressStageList = res.data;
      });
    },
    getsupplierList(projectId){
      getsupplierList({
        projectId:projectId
      }).then(res=>{
        this.supplierList = res.data
      })
    },
    initForm(){
      getDetail({
        id:this.rowData.id
      }).then(res=>{
        this.form = res.data
        this.form.progressStage+=''
        this.form.startupWay+=''
        this.$forceUpdate()
      })
    },
    handleClose(){
      this.visible = false 
      this.$emit("update:visible",this.visible)
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
    },
    submit(){
      console.log('表单',this.form)
      this.$refs['formRef'].validate(result=>{
        if(result){
          console.log('表单',this.form)
              switch (this.operatorModel){
              case 'add':
                  this.addRecord()
                  break;
              case 'update':
                    this.updateRecord()
                  break;
              case 'view':
                    // 
                  break;
              default :
                  // 
          }
          
        }
      })
      
    },
    addRecord(){
      add(this.form).then(res=>{
         this.$message.success("新增成功!")
          this.visible = false 
          this.$emit("update:visible",this.visible)
          this.$emit("afterSubmit")
      })
    },
    updateRecord(){
      update(this.form).then(res=>{
        this.$message.success("修改成功!")
         this.visible = false 
          this.$emit("update:visible",this.visible)
          this.$emit("afterSubmit")
      })
    }
  },
};
</script>
<style>
#lhr .lhrred{
  color: red !important;
  border-color: red;
}
</style>

<style scoped>
::v-deep .el-date-editor.el-input {
  width: 100%;
}

.tipDate{
  position: absolute;
    left: 2px;
    bottom: -26px;
}
::v-deep .el-form-item{
  position: relative;
  
}
 ::v-deep .el-col-8{
  height: 54px;
}
::v-deep .el-input-number {
  line-height: 30px;
}
</style>
